var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#FDFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 19.5H18.75C18.087 19.5 17.4511 19.7634 16.9823 20.2322C16.5134 20.7011 16.25 21.337 16.25 22V47C16.2472 47.4767 16.382 47.9441 16.6384 48.3461C16.8948 48.748 17.2618 49.0673 17.6954 49.2656C18.0257 49.4195 18.3856 49.4994 18.75 49.5C19.3369 49.4986 19.9043 49.2894 20.3516 48.9094L20.3657 48.8984L25.4688 44.5H46.25C46.9131 44.5 47.549 44.2366 48.0178 43.7678C48.4867 43.2989 48.75 42.663 48.75 42V22C48.75 21.337 48.4867 20.7011 48.0178 20.2322C47.549 19.7634 46.9131 19.5 46.25 19.5ZM37.5 35.75H27.5C27.1685 35.75 26.8506 35.6183 26.6162 35.3839C26.3817 35.1495 26.25 34.8315 26.25 34.5C26.25 34.1685 26.3817 33.8505 26.6162 33.6161C26.8506 33.3817 27.1685 33.25 27.5 33.25H37.5C37.8316 33.25 38.1495 33.3817 38.3839 33.6161C38.6184 33.8505 38.75 34.1685 38.75 34.5C38.75 34.8315 38.6184 35.1495 38.3839 35.3839C38.1495 35.6183 37.8316 35.75 37.5 35.75ZM37.5 30.75H27.5C27.1685 30.75 26.8506 30.6183 26.6162 30.3839C26.3817 30.1495 26.25 29.8315 26.25 29.5C26.25 29.1685 26.3817 28.8505 26.6162 28.6161C26.8506 28.3817 27.1685 28.25 27.5 28.25H37.5C37.8316 28.25 38.1495 28.3817 38.3839 28.6161C38.6184 28.8505 38.75 29.1685 38.75 29.5C38.75 29.8315 38.6184 30.1495 38.3839 30.3839C38.1495 30.6183 37.8316 30.75 37.5 30.75Z",
    fill: "#0040BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagenew);
export default __webpack_public_path__ + "static/media/messagenew.fc40da8070f176e475f7364e5ae3cfe6.svg";
export { ForwardRef as ReactComponent };